import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

@Injectable()
export class AdministracionMontosService {
  public url: String;

  constructor(private _http: HttpClient) {
    this.url = environment.apiLocalUrl + 'neoMontoIntermediario';
  }

  getMontosIF(idCliente): Observable<any> {
    return this._http.get(this.url + '/montosIF/' + idCliente).pipe(catchError(HandleHttpError));
  }

  saveMontosIF(montoIntermediarioDTO): Observable<any> {
    let body = JSON.stringify(montoIntermediarioDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/crear', body, { headers: headers }).pipe(catchError(HandleHttpError));
  }

  updateMontosIF(montoIntermediarioDTO): Observable<any> {
    let body = JSON.stringify(montoIntermediarioDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/modificar', body, { headers: headers }).pipe(catchError(HandleHttpError));
  }

  deleteMontosIF(montoIntermediarioDTO): Observable<any> {
    let body = JSON.stringify(montoIntermediarioDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/eliminar' , body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }
}
